import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const CommonContext = React.createContext(null);
export const CommonContextProvider = ({ setViewPosition, dispatchCommand, children, }) => {
    return (_jsx(CommonContext.Provider, { value: { setViewPosition, dispatchCommand }, children: children }));
};
export const useCommonContext = () => {
    const v = React.useContext(CommonContext);
    if (v === null) {
        throw new Error("useCommonContext must be used within a CommonContextProvider");
    }
    return v;
};
export const useDispatchCommand = () => {
    const { dispatchCommand } = useCommonContext();
    return dispatchCommand;
};
export function createCommonContextProvider(useSetViewPosition, useAppDispatchCommand) {
    return function AppCommonContextProvider({ children }) {
        const setViewPosition = useSetViewPosition();
        const dispatchCommand = useAppDispatchCommand();
        return (_jsx(CommonContextProvider, { setViewPosition: setViewPosition, dispatchCommand: dispatchCommand, children: children }));
    };
}
//# sourceMappingURL=commonContext.js.map